import { HTMLAttributes } from "react";
import SimpleBar from "simplebar-react";
import clsx from "clsx";

interface Props extends HTMLAttributes<HTMLDivElement> {
  children: React.ReactNode;
  wrapperClassName?: string;
  className?: string;
  autoHide?: boolean;
  hideScrollbar?: boolean;
}

export default function SimpleScrollBar({
  children,
  wrapperClassName = "pr-0.5",
  className,
  autoHide = false,
  hideScrollbar = false,
  ...props
}: Props) {
  return (
    <div className={wrapperClassName}>
      <SimpleBar
        className={clsx(className, { "hide-scrollbar": hideScrollbar })}
        autoHide={autoHide}
        {...props}
      >
        {children}
      </SimpleBar>
    </div>
  );
}
